import { FC } from 'react';
import { Modal, ModalBody, ModalHeader, FormGroup, Label, Col, Input } from 'reactstrap';
import { EntEventsLogType } from 'Src/Types';

interface INotificationModalWindowProps {
	/** Показывать? */
	isShow: boolean;
	/**  */
	isSuccess?: boolean;
	/**  */
	message?: string;
	/**  */
	date?: string | Date;
	/**  */
	additionData?: any;
	/**  */
	notification?: EntEventsLogType;
	/**  */
	close: () => void;
};

/** Модальное окно с подробным отображением уведомления */
const NotificationModalWindow: FC<INotificationModalWindowProps> = ( props ) => {

	const { notification, isSuccess, message = "", additionData, date, isShow, close } = props;

	// Подготовим поле Data, к выводу
	let dataString: string | undefined, _message = "", correctedDate, _isSuccess, _additionData;

	if ( !!notification ) {
		_message = notification.message;
		_isSuccess = notification.eventType !== 4;
		const date = new Date(notification.reccreated);
		const offset = new Date(Date.now()).getTimezoneOffset();
		correctedDate = new Date(date.setMinutes(-offset + date.getMinutes())).toLocaleString();
		_additionData = notification.data;
	}
	else {
		_isSuccess = isSuccess;
		_message = message;
		correctedDate = !!date && new Date(date).toLocaleString();
		_additionData = additionData;
	}

	if (_additionData != null) {
		if (typeof _additionData === 'string') {
			// Пытаемся распарсить как JSON
			const cleaned = _additionData
				.trim()
				// убираем BOM, если есть
				.replace(/^\uFEFF/, '');          

			try {
				const parsed = JSON.parse(cleaned);
				// Красиво форматируем
				dataString = JSON.stringify(parsed, null, '\t');
			} catch (err: any) {
				// Не валидный JSON
				dataString = _additionData;
			}
		} else {
			dataString = JSON.stringify(_additionData, null, '\t');
		}
	}

	return (
		<Modal isOpen={isShow} size="xl">

			<ModalHeader toggle={close}  className={_isSuccess ? "bg-success" : "bg-danger"}>
				{ _isSuccess ? "Успешно" : "Ошибка"}
			</ModalHeader>

			<ModalBody>
				
				<FormGroup row>
					<Label sm={1} className='rdev__notify__column-sm'>Сообщение:</Label>
					<Col sm={11} className='rdev__notify__column-md'>
						<div
							className='form-control rdev__notify__column-message'
							style={{ whiteSpace: 'pre-line' }}
							dangerouslySetInnerHTML={{ __html: _message }}
						/>
					 </Col>
				</FormGroup>

				{
					// если усть данные, то отобразим редактор
					!!dataString &&
					<FormGroup row>
						<Label sm={1} className='rdev__notify__column-sm'>Данные:</Label>
						<Col sm={11} className='rdev__notify__column-md'>
							<Input
								type="textarea"
								readOnly
								value={dataString}
								className='form-control'
								style={{ minHeight: '270px' }}
							/>
						</Col>
					</FormGroup>
				}
				
				<FormGroup row>
					<Label sm={1} className='rdev__notify__column-sm'>Время:</Label>
					<Col sm={11} className='rdev__notify__column-md'>
						<Input type="datetime" value={correctedDate} readOnly />
					</Col>
				</FormGroup>

			</ModalBody>
		</Modal>
	);
};

export default NotificationModalWindow;
